import {
	MASTERDATA_LOADING,
	MASTERDATA_SAVING_FAILED,
	MASTERDATA_SAVING_SUCCESSED,
} from "../actions/types";
const initialState = {
	data: {},
	isLoading:false,
	saved: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case MASTERDATA_LOADING:
			return {
				...state,
				isLoading:true,
				saved: false,
			};
		case MASTERDATA_SAVING_SUCCESSED:
			return {
				...state,
				data: action.payload,
				isLoading:false,
				saved: true,
			};
		case MASTERDATA_SAVING_FAILED:
			return {
				...state,
				isLoading:false,
				saved: false,
			};
		default:
			return state;
	}
}
